module.exports = __webpack_public_path__ + "static/images/details-1.5efc802.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product/ssk/details-1.png
// module id = SNHB
// module chunks = 0